import { IRI, SupportRequestState, SupporterRole } from "@api/schema"
import { IFilterCriteria } from "@redux/helper/actions"
import { IMarketSortOrder } from "@redux/usecases/marketplace"


export enum IPartnerMarketSortType {
  PublicUntil = "publicUntil",
  UpdatedAt = "updatedAt",
}

export interface IPartnerMarketSearchParams {
  supporterRoles: SupporterRole[]
  pattern?: string
  sortBy?: IPartnerMarketSortType
  sortOrder?: IMarketSortOrder
}

export const initialPartnerMarketSearchState: IPartnerMarketSearchParams = {
  supporterRoles: [],
  pattern: "",
  sortBy: IPartnerMarketSortType.UpdatedAt,
  sortOrder: IMarketSortOrder.DESC,
}

/**
 * This interface defines, what filter criteria are accepted by the API for SupportRequests
 */
export interface ISupportRequestFilterCriteria extends IFilterCriteria {
  id?: string
  /** IRI of one or many IProjects */
  project?: IRI | IRI[]
  state?: SupportRequestState
  supporterRole?: SupporterRole[]
  /** searches in title and content */
  pattern?: string
  /** order for update date */
  "order[updatedAt]"?: IMarketSortOrder
  /** order for publicUntil */
  "order[publicUntil]"?: IMarketSortOrder
}

/**
 * this data defines a picture/icon for a supporterRole
 */
export interface SupporterRolePicture {
  url: string
}

/**
 * a picture for a specific SupporterRole is defined as
 * SupporerRole => SupporterRolePicture
 */
export type SupporterRolePictureList = {
  [key in SupporterRole]: SupporterRolePicture
}

/**
 * This list assigns a picture url to every existing SupporterRole
 *
 */
export const supporterRolePictures: SupporterRolePictureList = {
  [SupporterRole.Contributor]: {
    url: "/assets/img/partner-market/team.svg",
  },
  [SupporterRole.Expert]: {
    url: "/assets/img/partner-market/knowledge.svg",
  },
  [SupporterRole.FeedbackProvider]: {
    url: "/assets/img/partner-market/partner.svg",
  },
  [SupporterRole.Ambassador]: {
    url: "/assets/img/partner-market/door-opener.svg",
  },
  [SupporterRole.Supplier]: {
    url: "/assets/img/partner-market/things.svg",
  },
  [SupporterRole.Sponsor]: {
    url: "/assets/img/partner-market/money.svg",
  },
}